"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    TENTATIVE: 'tentative',
    CONFIRMED: 'confirmed',
    UNSCHEDULED: 'unscheduled',
    DECLINED: 'declined',
    ACTION_REQUIRED: 'actionRequired',
    UPDATED: 'updated',
    READ_ONLY: 'readOnly',
    CANCELLED: 'cancelled',
    COMPLETED: 'completed',
    AUTO_COMPLETED: 'autoCompleted',
    DEFAULT: 'default',
    RESCHEDULED: 'rescheduled',
    DELETED: 'deleted',
};
//# sourceMappingURL=bookingStatus.js.map